<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading" >
    <mapfre-card [singleCard]="false" [additionalClasses]="'billing-cancellation-request fs-18 lh-24  policy-acct-txt-color'">
        <div class="border-bottom-1-9CB0BC fs-16 pb-3 mb-3" [ngClass]="{ 'mb-4': policy && policy.policyType.includes('AUTO') }">
            <h1 class="title-copy col-2d373d mb-0 dm-sans">{{ "CANCELLATION" | translate }}</h1>
            <ng-container *ngIf="policy && policy.policyType.includes('AUTO')" >
                <p class="mb-0 lh-20-83 mt-2">{{ "ADD_INFO_CANCEL_POLICY" | translate }}</p>
            </ng-container>
        </div>
        
        <app-billing-header 
            [policyTypeImg]="policyTypeImg" [policyType]="policyType" 
            [policyNumber]="policy?.policynumber.policyNumber" [policy]="policy"
        >
        </app-billing-header>

        <ng-container *ngIf="policy && policy.policyType.includes('AUTO'); else otherPolicyTypes" >
            <form name="requestFormGroup" class="ng-select-main submit-question-form"
                    [formGroup]="requestFormGroup" (ngSubmit)="sendRequest()"
                    [ngClass]="'text-left ma-submit-question-form mt-4'">
 
                <div class="input margin-bottom mb24">
                        <div class="fs-16 mb-4">
                        <label for="select-topic" class="select-label mb-0">{{ 'SELECT_CANCEL_REASON' | translate }}</label>     
                        <ng-select 
                        [items]="topicOptions" 
                        bindLabel="name" 
                        autofocus 
                        bindValue="name" 
                        [searchable]="false" 
                        [multiple]="false"
                        [clearable]="false" 
                        [markFirst]="false" 
                        placeholder="Select one" 
                        fixedPlaceholder="true"
                        [formControlName]="'cancellation_topic'"
                        (change)="onReasonChange()"> 
                        </ng-select>
                    </div>
                    <ng-container *ngIf="requestFormGroup.controls.cancellation_topic.valid">                               
                        <div class="mb-4 mt-2">
                            <label for="select-topic" class="select-label mb-0">{{ 'ADD_ADDITIONAL_INFO' | translate }}</label> 
                            <textarea formControlName="addInfo" [id]="'request-text'" [name]="'request-text'"
                                class="request-text" mdbInput placeholder="Type here">
                            </textarea>
                        </div>
                    </ng-container>   
                </div>

                <ng-container *ngIf="requestFormGroup.controls.cancellation_topic.valid">
                    <div class="mb-4 lh-20-83 fs-16">
                        <ng-container *ngIf="requestFormGroup.controls.cancellation_topic.value.includes('License');else insuranceTemp">
                            <p>{{ "UPLOAD_COPY_LICENSE_PLATE" | translate }}
                                <a href="https://www.mass.gov/how-to/cancel-your-vehicle-registration-license-plates" 
                                    target="_blank" class="see-dec nobr"> RMV website</a>.
                            </p>
                            <p></p>
                            <p class="mb-4"><strong>{{ "POLICY_NOY_CANCEL_UNTIL_PLATE" | translate }}</strong></p>
                        </ng-container>
                        <ng-template #insuranceTemp>
                            <span class="tool-tip-align cancellation-tooltip row-space-between margin-bottom mb8 col-2d373d">
                                <span class="margin-right mr8"><strong>{{ "NEXT_STEP" | translate }} {{ "MA_AUTO_TRANSFER_INSURANCE" | translate }}</strong></span>
                                <div class="ctooltip tooltip-positioning" (mouseenter)="onTolltipHover()" [ngClass]="{'tooltip-show': isTooltipVisible}">
                                    <img src="assets/img/images/icon-info-red.svg" alt="info icon "  class="tooltip-icon"/>
                                    <app-custom-tooltip [tooltipTitle]="tooltipTitle" [description]="tooltipDescription" (showTooltip)="showToolTip($event)"></app-custom-tooltip>
                                </div>
                            </span>
                            <p  class="mb-4">{{ "UPLOAD_MA_AUTO_TRANSFER_INSURANCE" | translate }}</p>
                        </ng-template>
                    </div>

                    <app-upload-request-documents (uploadFileEvent)="saveUploadedFile($event)">
                    </app-upload-request-documents>
                </ng-container>

                <div class="row text-center">
                    <div class="col">
                        <mapfre-button
                            [ngClass]="{'custom_loader':submitLoading}"
                            [additionalClasses]="'basic primary large-btn  mx-auto'"
                            [disabledValue]="requestFormGroup.controls.cancellation_topic.valid 
                                                && documents.length > 0" 
                            [inputType]="'submit'"
                            [translateValue]="'SUBMIT' | translate"
                        ></mapfre-button>
                    </div>
                </div>

                <div class="row text-center mt-3">
                    <div class="col">
                        <mapfre-button 
                        [additionalClasses]="'ghost secondary large-btn mx-auto height-56'"
                        [iconClasses]="'align-middle'" 
                        (click)="onClickBack()">
                        {{ 'BACK' | translate }}
                        </mapfre-button>
                    </div>
                </div>
            </form>
        </ng-container>

        <ng-template #otherPolicyTypes>
            <div class="mt-3 mb-4 lh-20-83 fs-16">
                <p>{{ cancelRequestInfo | translate }}
                    <a routerLink='/contact' class="see-dec nobr">
                        {{ 'CONTACT_YOUR_AGENT' | translate | lowercase}}</a>.
                </p>
            </div>

            <div class="row text-center">
                <div class="col">                  
                    <mapfre-button 
                    [additionalClasses]="'basic primary large-btn waves-effect'"
                    [iconClasses]="'align-middle'"
                    (click)="onClickClose()"> {{ 'CLOSE' | translate }}
                    </mapfre-button>
                </div>                
            </div>
        </ng-template>
    </mapfre-card>
</ng-container>

<app-leave-page-modal
    *ngIf="showLeaveModal"
      (isLeavingPage)="reload($event)">
</app-leave-page-modal>

<mapfre-modal
  *ngIf="showSubmitUnsuccessModal"
      [modalOptions]="failureSubmitModal"
      [hideModal]="hideModal"
      (closeModal)="resetHideModal()"
    >
    <app-request-unsuccess
        (isTryAgain)="tryAgain($event)">
    </app-request-unsuccess>
</mapfre-modal>

